export const BADGE_SHAPE_IDS = [
  'circle',
  'hexagon',
  'seal',
  'diamond',
  'roundedSquare',
  'shield',
  'rosette'
] as const

export type BadgeShapeId = (typeof BADGE_SHAPE_IDS)[number]

export type BadgeDisplaySymbol =
  | {
      kind: 'icon'
      iconName: string
    }
  | {
      kind: 'emoji'
      emoji: string
    }

export const BADGE_TONE_IDS = [
  'rose',
  'pink',
  'fuchsia',
  'purple',
  'violet',
  'indigo',
  'blue',
  'sky',
  'cyan',
  'highlight',
  'teal',
  'emerald',
  'green',
  'lime',
  'yellow',
  'amber',
  'orange',
  'lagoonLilac',
  'tealLime',
  'orangeFuchsia',
  'pinkPurple',
  'blueTeal',
  'limePeach',
  'violetRed',
  'fuchsiaTeal',
  'amberRed'
] as const

export type BadgeToneId = (typeof BADGE_TONE_IDS)[number]

export interface BadgeTone {
  border: string
  fillEnd: string
  fillStart: string
  icon: string
}

export const BADGE_TONES: Record<BadgeToneId, BadgeTone> = {
  amber: {
    border: '#78350F',
    fillEnd: '#FBBF24',
    fillStart: '#FDE68A',
    icon: '#78350F'
  },
  amberRed: {
    border: '#78350F',
    fillEnd: '#FBBF24',
    fillStart: '#FECACA',
    icon: '#78350F'
  },
  blue: {
    border: '#1E3A8A',
    fillEnd: '#60A5FA',
    fillStart: '#BFDBFE',
    icon: '#1E3A8A'
  },
  blueTeal: {
    border: '#1E3A8A',
    fillEnd: '#60A5FA',
    fillStart: '#99F6E4',
    icon: '#1E3A8A'
  },
  cyan: {
    border: '#164E63',
    fillEnd: '#22D3EE',
    fillStart: '#A5F3FC',
    icon: '#164E63'
  },
  emerald: {
    border: '#064E3B',
    fillEnd: '#34D399',
    fillStart: '#A7F3D0',
    icon: '#064E3B'
  },
  fuchsiaTeal: {
    border: '#7F1D1D',
    fillEnd: '#E879F9',
    fillStart: '#99F6E4',
    icon: '#7F1D1D'
  },
  fuchsia: {
    border: '#701A75',
    fillEnd: '#E879F9',
    fillStart: '#F5D0FE',
    icon: '#701A75'
  },
  green: {
    border: '#14532D',
    fillEnd: '#4ADE80',
    fillStart: '#BBF7D0',
    icon: '#14532D'
  },
  highlight: {
    border: '#2D6E78',
    fillEnd: '#60BCC8',
    fillStart: '#B8E5E9',
    icon: '#2D6E78'
  },
  indigo: {
    border: '#312E81',
    fillEnd: '#818CF8',
    fillStart: '#C7D2FE',
    icon: '#312E81'
  },
  lagoonLilac: {
    border: '#65277C',
    fillEnd: '#D090F0',
    fillStart: '#B8E5E9',
    icon: '#65277C'
  },
  lime: {
    border: '#365314',
    fillEnd: '#A3E635',
    fillStart: '#D9F99D',
    icon: '#365314'
  },
  limePeach: {
    border: '#365314',
    fillEnd: '#A3E635',
    fillStart: '#FED7AA',
    icon: '#365314'
  },
  orange: {
    border: '#C65D20',
    fillEnd: '#F89A5B',
    fillStart: '#FFD0A3',
    icon: '#9A3412'
  },
  orangeFuchsia: {
    border: '#7C2D12',
    fillEnd: '#FB923C',
    fillStart: '#F5D0FE',
    icon: '#7C2D12'
  },
  pink: {
    border: '#831843',
    fillEnd: '#F472B6',
    fillStart: '#FBCFE8',
    icon: '#831843'
  },
  pinkPurple: {
    border: '#831843',
    fillEnd: '#F472B6',
    fillStart: '#E9D5FF',
    icon: '#831843'
  },
  purple: {
    border: '#581C87',
    fillEnd: '#C084FC',
    fillStart: '#E9D5FF',
    icon: '#581C87'
  },
  rose: {
    border: '#881337',
    fillEnd: '#FB7185',
    fillStart: '#FECDD3',
    icon: '#881337'
  },
  sky: {
    border: '#0C4A6E',
    fillEnd: '#38BDF8',
    fillStart: '#BAE6FD',
    icon: '#0C4A6E'
  },
  teal: {
    border: '#134E4A',
    fillEnd: '#2DD4BF',
    fillStart: '#99F6E4',
    icon: '#134E4A'
  },
  tealLime: {
    border: '#134E4A',
    fillEnd: '#2DD4BF',
    fillStart: '#D9F99D',
    icon: '#134E4A'
  },
  violetRed: {
    border: '#7F1D1D',
    fillEnd: '#F87171',
    fillStart: '#DDD6FE',
    icon: '#7F1D1D'
  },
  violet: {
    border: '#4C1D95',
    fillEnd: '#A78BFA',
    fillStart: '#DDD6FE',
    icon: '#4C1D95'
  },
  yellow: {
    border: '#713F12',
    fillEnd: '#FACC15',
    fillStart: '#FEF08A',
    icon: '#713F12'
  }
}
